import { Tab } from './tab.model';
import { Section } from './section.model';
import { Injector } from '@angular/core';

export class SidePanel {
    public tabs: Tab[];
    public sections: Section[];
    public visible: boolean;
    public sidePanelLayout?: SidePanelLayout;
    public injector: Injector;

    constructor(data: any) {
        this.tabs = data.tabs;
        this.sections = data.sections;
        this.visible = data.visible;
        this.sidePanelLayout = data.sidePanelLayout;
        this.injector = data.injector;
    }
}

export interface SidePanelLayout {
    right?: boolean;
    thin?: boolean;
    constrainToScrolling?: boolean;
    forceSingleTab?: boolean;
    showTabsPhoneOnly?: boolean;
    hostPadding?: boolean;
    extraWide?: boolean;
}